import * as types from './config-mutation-types';

export default {
  [types.SET_CONFIG](state, payload) {
    state.customer_service = payload.customer_service;
    state.balance_config = payload.balance_config;
    state.order_review_config = payload.order_review_config;
    state.new_peer_coupon_amount = payload.new_peer_coupon_amount;
    state.sys_config = payload;
    state.recharge_amount = payload.recharge_amount;
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/config/config-mutations.js